import {
  BorderGreyBox,
  BoxSpg,
  handleSubmitValidationFail,
  NameFilter,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { SEARCH_FILTERS_GROUP } from "../../../../config/search/filters/groupsConfig";
import { RolesFilter } from "../../../../types/groupsAndRolesTypes";
import { rolesFilterInitialValues } from "../../../../init/groupsAndRolesFiltersInitialValues";
import { createRolesFilterValidationSchema } from "../../../../yup/schema/groupsAndRoles/rolesFilterValidationSchema";
import React, { useMemo } from "react";
import useSearchTableControl from "../../../../hooks/portal/search/useSearchTableControl";
import { searchRoles } from "../../../../axios/api/services";
import { FormProvider } from "react-hook-form";
import SearchFilters from "../../common/search/filters/SearchFilters";
import { useTranslation } from "react-i18next";
import RolesList from "./RolesList";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import RoleViewDialog from "./dialog/RoleViewDialog";
import RoleEditDialog from "./dialog/RoleEditDialog";
import DescriptionFilter from "../../common/search/filters/definition/DescriptionFilter";
import { Grid } from "@mui/material";

const RolesFilters = () => {
  return (
    <Grid container spacing={5} px={2} py={6}>
      <NameFilter />
      <DescriptionFilter />
    </Grid>
  );
};

const Roles = () => {
  const { t } = useTranslation();
  const group = SEARCH_FILTERS_GROUP.ROLES;

  const filtersData = useAppSelector((state) => {
    return state.SearchData.portalSearchTable[group].filtersData;
  });

  const { methods } = useReactHookForm<RolesFilter>({
    defaultValues: filtersData,
    validationSchema: createRolesFilterValidationSchema,
  });

  const control = useSearchTableControl({
    group,
    methods,
    initialValues: rolesFilterInitialValues,
    filterData: searchRoles,
    callAfterResetFilters: true,
  });

  return (
    <>
      <RoleViewDialog />
      <RoleEditDialog />
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(
            () => control.handleSubmitFilters(),
            () => handleSubmitValidationFail(methods.formState, t, undefined),
          )}
        >
          <BoxSpg mt={2}>
            <BorderGreyBox>
              <SearchFilters
                isSubmitBtnDisabled={control.isSubmitBtnDisabled}
                isResetBtnDisabled={control.isResetBtnDisabled}
                handleResetFilters={control.handleResetFilters}
              >
                {useMemo(
                  () => (
                    <RolesFilters />
                  ),
                  [],
                )}
              </SearchFilters>
            </BorderGreyBox>
            {control.showList && (
              <RolesList
                records={control.records}
                total={control.total}
                isLoading={control.isLoading}
                onPageOrOrderChange={control.handlePageOrOrderChange}
                blockTable={control.blockTable}
                group={group}
              />
            )}
          </BoxSpg>
        </form>
      </FormProvider>
    </>
  );
};

export default Roles;
